(() => {
  const initializeAbra = () => {
    window.Abra.useSellingPlanPriceOnProductBlock = true;
    if (window.Abra?.render) {
      window.Abra.render();
    }
  };

  const addClasses = () => {
    document.querySelector('.sls-option-container[data-prepaid="false"]:has([data-one-time-option-radio])')?.classList.add('one-time-purchase');
    document.querySelector('.sls-option-container[data-selling-plan-group-id]')?.classList.add('subscribe');
  };

  initializeAbra();
  addClasses();

  document.body.addEventListener('click', (e) => {
    const isOneTimeRadio = e.target.closest('[data-one-time-option-radio]') || 
                          e.target.matches('input[data-type="one_time"]') ||
                          (e.target.matches('[role="radio"]') && e.target.getAttribute('aria-label')?.includes('One-time'));
    
    const isSubscribeRadio = e.target.closest('[data-selling-plan-group-option-radio]') || 
                            e.target.matches('input[data-type="subscription"]') ||
                            (e.target.matches('[role="radio"]') && e.target.getAttribute('aria-label')?.includes('Subscribe'));
    
    if (isOneTimeRadio) {
      setTimeout(() => {
        if (window.Abra?.render) {
          window.Abra.render();
        }
      }, 500);
      
      setTimeout(() => {
        if (window.Abra?.render) {
          window.Abra.render();
        }
      }, 1000);
    } else if (isSubscribeRadio) {
      window.Abra.useSellingPlanPriceOnProductBlock = true;
      
      setTimeout(() => {
        if (window.Abra?.render) {
          window.Abra.render();
        }
      }, 500);
      
      setTimeout(() => {
        if (window.Abra?.render) {
          window.Abra.render();
        }
      }, 1000);
    }
  }, true);

  new MutationObserver(() => {
    addClasses();
  }).observe(document.body, { childList: true, subtree: true });
})();